module.exports = __webpack_public_path__ + "img/d-up-we-hustle-different.f4ff87c8.png";